import React from "react";
import PropTypes from "prop-types";
import { H2, Paragraph, Text } from "components/core/Typography";
import { Link } from "components/core/Link";
import { CircleArrow } from "components/core/Icons";
import { isUsableUri } from "utils/url";

import "./NearbyCities.scss";

const NearbyCity = ({ city }) => {
	const formattedCity = `${city.city}, ${city.state}`;
	const distanceText =
		city.distance > 1
			? `${city.distance} miles away`
			: `${city.distance} mile away`;
	return (
		<Link
			href={`/${city.uri}`}
			weight="semiBold"
			className="nearby-city-card"
		>
			<div>
				<Text
					weight="semiBold"
					color="blue"
				>
					{formattedCity}
				</Text>
				<Paragraph
					size="small"
					color="lightGray"
					last
				>
					{distanceText}
				</Paragraph>
			</div>
			<div className="nearby-city-button">
				<CircleArrow size="xlarge" />
			</div>
		</Link>
	);
};

NearbyCity.propTypes = {
	city: PropTypes.object
};

const NearbyCities = ({ nearbyCities, location }) => {
	const validCities = nearbyCities.filter((city) => isUsableUri(city?.uri));

	if (validCities.length === 0) {
		return null;
	}

	return (
		<div className="nearby-cities">
			<H2 size="large">
				Browse Storage Units in Nearby {location?.fullState || ""}{" "}
				Cities
			</H2>
			<div className="nearby-city-container">
				{validCities.map((city) => (
					<NearbyCity
						city={city}
						key={city.uri}
					/>
				))}
			</div>
		</div>
	);
};

NearbyCities.propTypes = {
	nearbyCities: PropTypes.arrayOf(PropTypes.object),
	location: PropTypes.object
};

export default NearbyCities;
